<template>
  <div class="register-page">
    <main class="register-shell">
      <section class="register-card">
        <div class="brand">
          <img class="brand-logo" src="@/static/logo.jpg" alt="OttDrama" />
          <h1>{{ $t('auth.registerTitle') }}</h1>
          <p>{{ $t('auth.registerSubtitle') }}</p>
        </div>

        <van-tabs
          v-model="activeTab"
          class="register-tabs"
          color="#111111"
          line-width="28px"
          line-height="3px"
          title-active-color="#111111"
          title-inactive-color="#8a8a8f"
          swipeable
          animated
        >
          <van-tab :title="$t('auth.phoneTab')">
            <van-form class="register-form" @submit="handleSubmit">
              <van-field
                v-model.trim="form.phone"
                name="phone"
                type="tel"
                :label="$t('auth.phone')"
                :placeholder="$t('auth.phonePlaceholder')"
                autocomplete="tel"
                clearable
              />
              <van-field
                v-model.trim="form.nickname"
                name="nickname"
                :label="$t('auth.nickname')"
                :placeholder="$t('auth.nicknamePlaceholder')"
                autocomplete="nickname"
                clearable
              />
              <van-field
                v-model="form.password"
                name="password"
                type="password"
                :label="$t('auth.password')"
                :placeholder="$t('auth.passwordPlaceholder')"
                autocomplete="new-password"
                clearable
              />
              <van-field
                v-model="form.repassword"
                name="repassword"
                type="password"
                :label="$t('auth.repassword')"
                :placeholder="$t('auth.repasswordPlaceholder')"
                autocomplete="new-password"
                clearable
              />
              <van-button
                class="submit-btn"
                block
                round
                type="info"
                native-type="submit"
              >
                {{ $t('auth.registerAction') }}
              </van-button>
            </van-form>
          </van-tab>

          <van-tab :title="$t('auth.emailTab')">
            <van-form class="register-form" @submit="handleSubmit">
              <van-field
                v-model.trim="form.email"
                name="email"
                type="email"
                :label="$t('auth.email')"
                :placeholder="$t('auth.emailPlaceholder')"
                autocomplete="email"
                clearable
              />
              <van-field
                v-model.trim="form.nickname"
                name="nickname"
                :label="$t('auth.nickname')"
                :placeholder="$t('auth.nicknamePlaceholder')"
                autocomplete="nickname"
                clearable
              />
              <van-field
                v-model="form.password"
                name="password"
                type="password"
                :label="$t('auth.password')"
                :placeholder="$t('auth.passwordPlaceholder')"
                autocomplete="new-password"
                clearable
              />
              <van-field
                v-model="form.repassword"
                name="repassword"
                type="password"
                :label="$t('auth.repassword')"
                :placeholder="$t('auth.repasswordPlaceholder')"
                autocomplete="new-password"
                clearable
              />
              <van-button
                class="submit-btn"
                block
                round
                type="info"
                native-type="submit"
              >
                {{ $t('auth.registerAction') }}
              </van-button>
            </van-form>
          </van-tab>
        </van-tabs>

        <div class="login-entry">
          <span>{{ $t('auth.hasAccount') }}</span>
          <button type="button" @click="goLogin">{{ $t('auth.goLogin') }}</button>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { userRegister } from '@/apis/login.js'
import { Toast } from 'vant'

export default {
  name: 'RegisterPage',
  data() {
    return {
      activeTab: 0,
      form: {
        phone: '',
        email: '',
        nickname: '',
        password: '',
        repassword: ''
      }
    }
  },
  methods: {
    goLogin() {
      this.$router.push('/base/login')
    },
    handleSubmit() {
      const error = this.validateForm()

      if (error) {
        Toast(error)
        return
      }

      const registerData = {
        phone: this.activeTab === 0 ? this.form.phone : '',
        email: this.activeTab === 1 ? this.form.email : '',
        nickname: this.form.nickname,
        password: this.form.password,
        repassword: this.form.repassword
      }
      userRegister(registerData)
        .then(({ data }) => {
          if (data) {
            Toast(this.$t('auth.registerSuccess'))
            this.$router.push('/base/login')
          } else {
            Toast(this.$t('auth.registerFailed'))
          }
        })
        .catch(() => {
          Toast(this.$t('auth.registerFailed'))
        })
    },
    validateForm() {
      if (this.activeTab === 0 && !/^\+?[0-9]{6,20}$/.test(this.form.phone)) {
        return this.$t('auth.invalidPhone')
      }

      if (this.activeTab === 1 && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
        return this.$t('auth.invalidEmail')
      }

      if (!this.form.nickname || this.form.nickname.length < 2) {
        return this.$t('auth.invalidNickname')
      }

      if (!this.form.password || this.form.password.length < 6) {
        return this.$t('auth.invalidPassword')
      }

      if (this.form.password !== this.form.repassword) {
        return this.$t('auth.passwordMismatch')
      }

      return ''
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}

.register-page {
  min-height: 100vh;
  background:
    radial-gradient(circle at 16% 10%, rgba(255, 255, 255, 0.95), transparent 28%),
    linear-gradient(145deg, #f7f8fb 0%, #eef1f5 48%, #ffffff 100%);
  color: #111111;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif;
}

.register-shell {
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding: 40px 20px 34px;
}

.register-card {
  width: 100%;
  max-width: 430px;
  align-self: flex-start;
  padding: 30px 22px 24px;
  background: rgba(255, 255, 255, 0.74);
  border: 1px solid rgba(255, 255, 255, 0.88);
  border-radius: 28px;
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
}

.brand {
  margin-bottom: 22px;
  text-align: center;
}

.brand-logo {
  width: 74px;
  height: 74px;
  margin-bottom: 16px;
  object-fit: cover;
}

.brand h1 {
  margin: 0;
  color: #111111;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.16;
  letter-spacing: 0;
}

.brand p {
  max-width: 280px;
  margin: 10px auto 0;
  color: #6e6e73;
  font-size: 14px;
  line-height: 1.55;
}

.register-tabs {
  overflow: hidden;
  border-radius: 20px;
}

.register-tabs ::v-deep .van-tabs__wrap {
  height: 48px;
  margin-bottom: 18px;
  border-radius: 16px;
  background: rgba(242, 243, 247, 0.96);
}

.register-tabs ::v-deep .van-tabs__nav {
  background: transparent;
}

.register-tabs ::v-deep .van-tab {
  font-size: 15px;
  font-weight: 600;
}

.register-tabs ::v-deep .van-tabs__line {
  bottom: 8px;
  border-radius: 999px;
}

.register-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.register-form ::v-deep .van-cell {
  display: flex;
  align-items: center;
  min-height: 54px;
  padding: 9px 14px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.register-form ::v-deep .van-cell::after {
  display: none;
}

.register-form ::v-deep .van-field__label {
  display: flex;
  align-items: center;
  width: 72px;
  color: #3a3a3c;
  font-size: 14px;
  font-weight: 600;
}

.register-form ::v-deep .van-field__body {
  display: flex;
  align-items: center;
  min-height: 34px;
}

.register-form ::v-deep .van-field__control {
  color: #111111;
  font-size: 15px;
  line-height: 22px;
}

.register-form ::v-deep .van-field__control::placeholder {
  color: #b0b0b7;
}

.submit-btn {
  height: 52px;
  margin-top: 8px;
  border: 0;
  background: #111111;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  box-shadow: 0 16px 30px rgba(17, 17, 17, 0.18);
}

.submit-btn:active {
  transform: translateY(1px);
}

.login-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 22px;
  color: #7a7a80;
  font-size: 14px;
}

.login-entry button {
  padding: 0;
  border: 0;
  background: transparent;
  color: #007aff;
  font-size: 14px;
  font-weight: 700;
}

@media (max-width: 380px) {
  .register-shell {
    padding-right: 14px;
    padding-left: 14px;
  }

  .register-card {
    padding: 26px 16px 22px;
    border-radius: 24px;
  }

  .brand h1 {
    font-size: 27px;
  }

  .register-form ::v-deep .van-field__label {
    width: 66px;
  }
}
</style>
